import { storeToRefs } from 'pinia';
import { useAuthStore } from '../stores/authStore';

export const useAuth = () => {
  const authStore = useAuthStore();

  const { user, isLoading, role } = storeToRefs(authStore);

  return {
    user,
    isLoading,
    role,
    authStore,
    forceUserUpdate: authStore.forceUserUpdate,
  };
};